import React, { useState, useMemo } from 'react'
import { ShadLineChart } from '../ShadChart';

const chartConfig = {
    // visitors: { label: "Visitors" },
    // leaving: { label: "יוצאים", color: "hsl(var(--chart-1))" },
    // entering: { label: "נכנסים", color: "hsl(var(--chart-2))" },
    sum: {label: "תפוסה", color: "#60A3D9"}
};

const locationHebrewName = {
    "KURSI_BEACH": "חוף כורסי",
    "SHIKMIM": "חוף שיקמים",
    "TSINBERI": "חוף צינברי",
}

const cardDescription="תפוסת רכבים על לפי שעה";

function YsbLineChartOccupancy({ data, deviceNames, lineDeviceName, setLineDeviceName }) {
    // const [activeMonth, setActiveMonth] = React.useState(deviceNames[0]);
    const [timeRange, setTimeRange] = useState("24h");
    console.log(data, "chartData");

    // Memoize the filtered data based on timeRange and data
    const filteredData = useMemo(() => {
        if (!data || data.length === 0) return [];
        const referenceDate = new Date(data[data.length - 1].date);

        const daysToSubtract = {
            "8h": 8,
            "24h": 24,
            "48h": 48,
            "3d": 72,
            "1w": 168,
        }[timeRange] || 168;

        const startDate = new Date(referenceDate);
        startDate.setHours(referenceDate.getHours() - daysToSubtract);

        return data.filter((item) => new Date(item.date) >= startDate);
    }, [timeRange, data]);

    // let buffArr = [];

    // const filteredDataOccupancy = filteredData.map((fd,i)=>{
    //     if(i === 0){
    //         buffArr.push(fd.entering - fd.leaving)
    //         return{occupancy: fd.entering - fd.leaving, date: fd.date}
    //     } /* else if(i === filteredData.length - 1){
    //         return{occupancy: filteredData[i-1].entering - filteredData[i-1].leaving, ...fd}
    //     } */ else {
    //         let lastValue = buffArr[buffArr.length-1];
    //         buffArr.push((fd.entering - fd.leaving)+ lastValue);
    //         return{occupancy: (fd.entering - fd.leaving) + lastValue/* (filteredData[i-1].entering - filteredData[i-1].leaving) */, date: fd.date}
    //     }
    // });
    //     console.log(buffArr,"buf");

    const filterDayOptions = [
        {
            value: "8h",
            filterDayOptionComponent: <>
                <div>שעות אחרונות</div>
                <div>8</div>
            </>
        },
        {
            value: "24h",
            filterDayOptionComponent: <>
                <div>שעות אחרונות</div>
                <div>24</div>
            </>
        },
        {
            value: "48h",
            filterDayOptionComponent: <>
                <div>שעות אחרונות</div>
                <div>48</div>
            </>
        },
        {
            value: "3d",
            filterDayOptionComponent: <>
                <div>ימים אחרונים</div>
                <div>3</div>
            </>
        },
        {
            value: "1w",
            filterDayOptionComponent: <>
                <div>שבוע חולף</div>
            </>
        },
    ];

    return (
        <ShadLineChart
            timeRange={timeRange}
            setTimeRange={setTimeRange}
            filterDayOptions={filterDayOptions}
            lineDeviceName={lineDeviceName}
            setLineDeviceName={setLineDeviceName}
            deviceNames={deviceNames}
            locationHebrewName={locationHebrewName}
            chartConfig={chartConfig}
            filteredData={filteredData}
            chartContainerStyle="aspect-auto h-[210px] w-full overflow-hidden"
            dots={true}
            cardDescription={cardDescription}
        />
    );
}

export default YsbLineChartOccupancy;